import {
  APPLY_REVOKE_SANCTION_ERROR,
  APPLY_REVOKE_SANCTION_SUCCESS,
  APPLY_REVOKE_SANCTION,
  CLOSE_FEEDBACK_DIALOG,
  CLOSE_REVOKE_DIALOG_SANCTION,
  DOWNLOAD_REVOKE_FILE_ERROR,
  DOWNLOAD_REVOKE_FILE_SUCCESS,
  DOWNLOAD_REVOKE_FILE,
  DOWNLOAD_SANCTION_FILE_ERROR,
  DOWNLOAD_SANCTION_FILE_SUCCESS,
  DOWNLOAD_SANCTION_FILE,
  GET_ATTACHMENTS_TYPES_ERROR,
  GET_ATTACHMENTS_TYPES_SUCCESS,
  GET_ATTACHMENTS_TYPES,
  GET_PO_BIDDING_INFO_ERROR,
  GET_PO_BIDDING_INFO_SUCCESS,
  GET_PO_BIDDING_INFO,
  GET_SANCTION_DETAILS_ERROR,
  GET_SANCTION_DETAILS_SUCCESS,
  GET_SANCTION_DETAILS,
  GET_SANCTIONS_TYPES_ERROR,
  GET_SANCTIONS_TYPES_SUCCESS,
  GET_SANCTIONS_TYPES,
  GET_USER_INFO_ERROR,
  GET_USER_INFO_SUCCESS,
  GET_USER_INFO,
  OPEN_REVOKE_DIALOG_SANCTION,
  REGISTER_SANCTION_ERROR,
  REGISTER_SANCTION_SUCCESS,
  REGISTER_SANCTION,
  SELECT_SANCTION_ATTACHMENT,
  SET_FORM_DATA,
  SET_INITIAL_STATE,
  UPDATE_FORM_VALUE,
  UPLOAD_SANCTION_ATTACHMENT_ERROR,
  UPLOAD_SANCTION_ATTACHMENT,
  WITHDRAW_SANCTION,
  WITHDRAW_SANCTION_ERROR,
  WITHDRAW_SANCTION_SUCCESS
} from './Sanction.actions'

const sanctionState = {
  canWithdraw: false,
  canRevoke: false,
  retiroVigente: false,
  codeSanction: null,
  attachmentsWS: [],
  downloading: false,
  downloadError: undefined,
  downloadingWS: null,
  downloadWSError: undefined,
  loading: false,
  error: undefined,
  success: false,
  showFeedbackDialog: false,
  sanctionID: 0,
  userInfo: {
    loading: true,
    error: undefined,
    orgName: '',
    unitName: '',
    fullName: '',
    position: '',
    phone: '',
    email: ''
  },
  poBiddingInfo: {
    id: '',
    loading: true,
    error: undefined,
    code: '',
    name: '',
    shippingDate: '',
    acceptanceDate: '',
    openingDate: '',
    closingDate: '',
    origin: '',
    originName: '',
    amountUTM: 0,
    state: '',
    hasContract: false,
    entCode: '',
    isPM: false,
    processType: 'PO'
  },
  sanctionsTypes: {
    loading: true,
    error: undefined,
    data: []
  },
  attachmentsTypes: {
    loading: true,
    error: undefined,
    data: []
  },
  form: {
    attachment: {
      docFolio: 0,
      file: null,
      fileName: '',
      applicationType: '',
      isMigrated: false
    },
    attachmentType: '',
    backupDate: new Date(),
    isSGC: false,
    reason: '',
    resolutionNumber: '',
    sanctionType: '',
    contractUrl: ''
  },
  revoke: {
    showDialog: false,
    reloadSanction: false,
    attachment: {
      docFolio: 0,
      file: null,
      fileName: '',
      applicationType: '',
      isMigrated: false
    }
  }
}

/**
 * The sanction reducer.
 */
const sanctionReducer = (state = sanctionState, { payload, type }) => {
  switch (type) {
    case SET_INITIAL_STATE: {
      return {
        ...state,
        loading: false,
        downloading: false,
        downloadError: undefined,
        error: undefined,
        success: false,
        showFeedbackDialog: false,
        sanctionID: 0,
        poBiddingInfo: sanctionState.poBiddingInfo,
        form: sanctionState.form,
        userInfo: sanctionState.userInfo
      }
    }
    case SET_FORM_DATA: {
      return {
        ...state,
        loading: false,
        downloading: false,
        downloadError: undefined,
        error: undefined,
        success: false,
        showFeedbackDialog: false,
        sanctionID: 0,
        poBiddingInfo: sanctionState.poBiddingInfo,
        form: sanctionState.form
      }
    }
    case GET_USER_INFO: {
      return { ...state, userInfo: { loading: true } }
    }
    case GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        userInfo: {
          loading: false,
          orgName: payload.orgName,
          fullName: payload.fullName,
          position: payload.position,
          phone: payload.phone,
          email: payload.email
        }
      }
    }
    case GET_USER_INFO_ERROR: {
      return {
        ...state,
        userInfo: {
          loading: false,
          error: payload.error
        }
      }
    }
    case GET_PO_BIDDING_INFO: {
      return { ...state, poBiddingInfo: { loading: true } }
    }
    case GET_PO_BIDDING_INFO_SUCCESS: {
      return {
        ...state,
        poBiddingInfo: {
          id: payload.id,
          loading: false,
          code: payload.code,
          name: payload.name,
          shippingDate: payload.shippingDate,
          acceptanceDate: payload.acceptanceDate,
          openingDate: payload.openingDate,
          closingDate: payload.closingDate,
          origin: payload.origin,
          originName: payload.originName,
          amountUTM: payload.amountUTM,
          state: payload.state,
          hasContract: payload.hasContract,
          entCode: payload.entCode,
          isPM: payload.isPM,
          processType: payload.processType
        }
      }
    }
    case GET_PO_BIDDING_INFO_ERROR: {
      return {
        ...state,
        poBiddingInfo: {
          ...state.poBiddingInfo,
          loading: false,
          error: payload.error
        }
      }
    }
    case GET_SANCTIONS_TYPES: {
      return { ...state, sanctionsTypes: { loading: true } }
    }
    case GET_SANCTIONS_TYPES_SUCCESS: {
      return {
        ...state,
        sanctionsTypes: {
          loading: false,
          data: payload.sanctionsTypes
        },
        form: {
          ...state.form,
          sanctionType: payload.defaultSanctionType
        }
      }
    }
    case GET_SANCTIONS_TYPES_ERROR: {
      return {
        ...state,
        sanctionsTypes: {
          loading: false,
          error: payload.error
        }
      }
    }
    case GET_ATTACHMENTS_TYPES: {
      return { ...state, attachmentsTypes: { loading: true } }
    }
    case GET_ATTACHMENTS_TYPES_SUCCESS: {
      return {
        ...state,
        attachmentsTypes: {
          loading: false,
          data: payload.attachmentsTypes
        },
        form: {
          ...state.form,
          attachmentType: payload.defaultAttachmentType
        }
      }
    }
    case GET_ATTACHMENTS_TYPES_ERROR: {
      return {
        ...state,
        attachmentsTypes: {
          loading: false,
          error: payload.error
        }
      }
    }
    case SELECT_SANCTION_ATTACHMENT: {
      return {
        ...state,
        form: {
          ...state.form,
          attachment: payload.attachment
        }
      }
    }
    case UPDATE_FORM_VALUE: {
      return {
        ...state,
        form: {
          ...state.form,
          [payload.name]: payload.value
        }
      }
    }
    case REGISTER_SANCTION:
    case UPLOAD_SANCTION_ATTACHMENT:
    case WITHDRAW_SANCTION: {
      return {
        ...state,
        loading: true,
        success: false
      }
    }
    case REGISTER_SANCTION_ERROR:
    case UPLOAD_SANCTION_ATTACHMENT_ERROR:
    case WITHDRAW_SANCTION_ERROR: {
      return {
        ...state,
        loading: false,
        error: payload.error,
        success: false,
        showFeedbackDialog: true
      }
    }
    case REGISTER_SANCTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        showFeedbackDialog: true,
        sanctionID: payload.sanctionID,
        error: undefined
      }
    }
    case WITHDRAW_SANCTION_SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        showFeedbackDialog: true,
        error: undefined
      }
    }
    case CLOSE_FEEDBACK_DIALOG: {
      return {
        ...state,
        showFeedbackDialog: false
      }
    }
    case GET_SANCTION_DETAILS: {
      return {
        ...state,
        poBiddingInfo: { loading: true },
        userInfo: { loading: true }
      }
    }
    case GET_SANCTION_DETAILS_SUCCESS: {
      return {
        ...state,
        codeSanction: payload.codeSanction,
        canWithdraw: payload.canWithdraw,
        canRevoke: payload.canRevoke,
        retiroVigente: payload.retiroVigente,
        attachmentsWS: payload.attachmentsWS || [],
        sanctionID: payload.sanctionID,
        form: {
          ...payload.form
        },
        poBiddingInfo: {
          ...payload.poBiddingInfo,
          loading: false
        },
        userInfo: {
          ...payload.userInfo,
          loading: false
        }
      }
    }
    case GET_SANCTION_DETAILS_ERROR: {
      return {
        ...state,
        poBiddingInfo: {
          loading: false,
          error: payload.error
        },
        userInfo: {
          loading: false,
          error: payload.error
        }
      }
    }
    case DOWNLOAD_SANCTION_FILE: {
      return {
        ...state,
        downloading: true
      }
    }
    case DOWNLOAD_SANCTION_FILE_SUCCESS: {
      return {
        ...state,
        downloading: false,
        form: {
          ...state.form,
          attachment: {
            ...state.form.attachment,
            file: payload.file
          }
        }
      }
    }
    case DOWNLOAD_SANCTION_FILE_ERROR: {
      return {
        ...state,
        downloading: false,
        downloadError: payload.error
      }
    }
    case DOWNLOAD_REVOKE_FILE: {
      return {
        ...state,
        downloadingWS: payload.atcCode,
        downloadWSError: undefined
      }
    }
    case DOWNLOAD_REVOKE_FILE_SUCCESS: {
      return {
        ...state,
        downloadingWS: null
      }
    }
    case DOWNLOAD_REVOKE_FILE_ERROR: {
      return {
        ...state,
        downloadingWS: null,
        downloadWSError: payload.error
      }
    }
    case OPEN_REVOKE_DIALOG_SANCTION: {
      return { ...state, revoke: { ...state.revoke, showDialog: true } }
    }
    case CLOSE_REVOKE_DIALOG_SANCTION: {
      return { ...state, revoke: { ...state.revoke, showDialog: false } }
    }
    case APPLY_REVOKE_SANCTION_ERROR:
    case APPLY_REVOKE_SANCTION: {
      return { ...state, revoke: { ...state.revoke, reloadSanction: false } }
    }
    case APPLY_REVOKE_SANCTION_SUCCESS: {
      return { ...state, revoke: { ...state.revoke, reloadSanction: true } }
    }
    default: {
      return state
    }
  }
}

export default sanctionReducer
